import React, { useEffect, useState } from 'react';
import { waLink, WaIcon } from '../App';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handle = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handle, { passive: true });
    return () => window.removeEventListener('scroll', handle);
  }, []);

  const navLink = { fontWeight: 600, fontSize: 14.5, color: 'var(--ink-2)', transition: 'color .2s' };

  return (
    <header
      id="top"
      style={{
        position: 'sticky', top: 0, zIndex: 60,
        background: 'rgba(250,243,238,.82)', backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${scrolled ? 'var(--line)' : 'transparent'}`,
        boxShadow: scrolled ? '0 8px 24px -22px rgba(93,62,80,.6)' : 'none',
        transition: 'border-color .3s, box-shadow .3s',
      }}
    >
      <div style={{ display:'flex', alignItems:'center', gap:22, padding:'14px 26px', maxWidth:1180, margin:'0 auto' }}>
        <a href="#top" style={{ display:'flex', alignItems:'center', gap:11 }}>
          <img src="/assets/kreme-tops-logo.jpg" alt="Kreme Tops Bakery logo"
            style={{ width:42, height:42, borderRadius:'50%', border:'1.5px solid var(--line)', objectFit:'cover', objectPosition:'50% 30%' }} />
          <span>
            <span style={{ fontFamily:'var(--serif)', fontWeight:700, fontSize:23, color:'var(--plum-deep)', lineHeight:.9, display:'block' }}>Kreme Tops</span>
            <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:9.5, letterSpacing:3, textTransform:'uppercase', color:'var(--ink-3)' }}>Bakery</span>
          </span>
        </a>

        <nav className="kt-nav-links" style={{ display:'flex', gap:26, marginLeft:'auto' }}>
          {[['#story','Story'],['#gallery','Gallery'],['#bake','What we bake'],['#menu','Menu']].map(([href,label]) => (
            <a key={href} href={href} style={navLink}
              onMouseOver={e => e.currentTarget.style.color='var(--plum)'}
              onMouseOut={e => e.currentTarget.style.color='var(--ink-2)'}
            >{label}</a>
          ))}
        </nav>

        <a href={waLink("Hi Kreme Tops! I'd love to order a cake.")} target="_blank" rel="noopener noreferrer"
          style={{ marginLeft:4, display:'inline-flex', alignItems:'center', gap:9, fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, letterSpacing:.2, padding:'14px 24px', borderRadius:40, border:'1.6px solid transparent', background:'var(--plum)', color:'#fff', boxShadow:'var(--shadow-sm)', cursor:'pointer', whiteSpace:'nowrap', textDecoration:'none' }}>
          <WaIcon />Order on WhatsApp
        </a>
      </div>

      <style>{`@media(max-width:860px){.kt-nav-links{display:none!important;}}`}</style>
    </header>
  );
}
